import { memo } from "react";
import { ECommerceOnboarding } from "consts/ecommerce";
import { useOnboardingApplication } from "./hooks";
import { OnboardingInitialStepRedirect } from "../common";

type Props = {
    readonly prefix?: string;
};

const OnboardingHighRiskMerchantInitialStepRedirect = ({ prefix = '' }: Props) => {
    const {
        getApplicationModel
    } = useOnboardingApplication();

    return (
        <OnboardingInitialStepRedirect
            getApplicationModel={getApplicationModel}
            prefix={prefix}
            applicationType={ECommerceOnboarding.HighRiskMerchant}
        />
    );
};

export default memo(OnboardingHighRiskMerchantInitialStepRedirect);
